/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2023-11-16 11:41:29
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-03-13 11:39:07
 */
import type { Reducer, Effect } from 'umi'
import { getAccountlist } from '@/services/system/account'

interface StateType {
  processor: any[]
  currentProcessor: any[]
}

export interface LogModelType {
  namespace: string
  state: StateType
  effects: {
    fetchProcessor: Effect
  }
  reducers: {
    saveProcessor: Reducer<StateType>
  }
}

const IndexModel: LogModelType = {
  namespace: 'deal',

  state: {
    processor: [], // 更进人列表
    currentProcessor: [] // 当前更进人列表
  },

  effects: {
    // 获取跟进人
    *fetchProcessor({ payload }, { call, put }) {
      const res = yield call(getAccountlist, { page: 1, size: 9999 })
      if (res.code === 0) {
        yield put({
          type: 'saveProcessor',
          payload: res.data.list
        })
      }
    }
  },

  reducers: {
    saveProcessor(state, { payload }): any {
      const obj = {}
      payload.forEach((item: any) => {
        obj[item.id] = { text: item.name_en }
      })
      return {
        ...state,
        processor: obj
      }
    }
  }
}

export default IndexModel
